export const setupWizard = {
  top: {
    title: "Assistant de configuration",
    subtitleFallback: "Configuration de base de l'annonce",
    stepCount: "Étape {current} sur {total}",
    closeAria: "Fermer l'assistant",
    closeTitle: "Fermer",
  },
  intro: {
    title: "Configurons votre logement ensemble !",
    subBefore: "Nous vous guiderons étape par étape pour que",
    yourListingFallback: "votre annonce",
    subAfter: "soit prête à accueillir des voyageurs. Aucune compétence technique requise : tout sera prêt en quelques minutes. 😊",
    start: "C'est parti !",
    skip: "Pas maintenant, je le ferai plus tard",
  },
  steps: {
    confirmation: {
      label: "Confirmation de réservation",
      desc: "Nous informons le voyageur que sa réservation est confirmée par WhatsApp et e-mail. Désactivez ceci et il ne sera pas notifié. S'il réserve via une OTA, c'est l'OTA qui le notifie.",
    },
    welcome: {
      label: "Message de bienvenue",
      desc: "Le message que le voyageur reçoit juste après avoir terminé son check-in en ligne, avec la bienvenue et les instructions d'arrivée.",
    },
    schedule: {
      label: "Planification du check-in",
      desc: "Quand souhaitez-vous que nous envoyions au voyageur le lien de check-in ?",
    },
    hours: {
      label: "Heures de check-in et check-out",
      desc: "À quelle heure le voyageur peut-il arriver et partir ?",
    },
    locks: {
      label: "Type de serrure",
      desc: "Comment le voyageur entre-t-il dans votre logement ?",
    },
    authorities: {
      label: "Déclaration aux autorités",
      desc: "Nous envoyons le rapport voyageurs aux autorités pour vous, sans rien à faire de votre côté.",
    },
    services: {
      label: "Services",
      desc: "Configurez les services et équipements que votre logement propose.",
    },
    policies: {
      label: "Règles",
      desc: "Les règles et conditions de votre logement.",
    },
    calendar: {
      label: "Préparez votre calendrier",
      desc: "Nous vous montrerons comment préparer votre calendrier pour recevoir des réservations.",
    },
  },
  nav: {
    back: "Retour",
    next: "Suivant",
    finish: "Terminer",
  },
  preview: {
    audienceOwner: "Ce que vous voyez (hôte)",
    audienceGuest: "Ce que le voyageur voit",
    accommodationFallback: "Logement",
    online: "en ligne",
    today: "Aujourd'hui",
    captionGuestWeb: "Aperçu · web voyageur",
  },
  schedule: {
    title: "Quand le check-in commence-t-il ?",
    hint: "Planifiez le moment où l'agent envoie le lien de check-in au voyageur. S'applique au niveau de l'annonce.",
    caption: "Aperçu · séquence de check-in",
  },
  // WhatsApp bot sample messages: shown VERBATIM (bilingual ES+EN) in every
  // language because they mirror the actual product message.
  checkin: {
    propFallback: "tu alojamiento",
    greeting: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{name}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
    quote: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*. Estoy aquí para ayudarte con el proceso de che…",
    subCheckin: "Vamos a hacer el check-in · Let's check-in",
    ok: "Ok",
    chooseLang: "Elige tu idioma",
    langEs: "Español",
    langEn: "English",
    thanks: "*Gracias* 👋 Este es tu link para hacer el Check-In. 😎",
  },
  confirmation: {
    toggleLabel: "Voulez-vous que la confirmation de réservation soit envoyée au voyageur par WhatsApp ?",
    toggleHint: "Dès qu'une réservation est confirmée, il recevra ce message avec tous les détails de son séjour. Ainsi, il sait que tout est en ordre. 😊",
    stateOn: "Oui, l'envoyer",
    stateOff: "Ne pas envoyer",
    mapAlt: "Emplacement du logement",
    addressFallback: "Adresse du logement",
    caption: "Aperçu · message de confirmation",
    propFallback: "votre logement",
    guestSample: "Laura García",
    body: "Bonjour *{guest}* 👋\n\nVotre réservation chez *{name}* est confirmée ✅\n\nCode de réservation : *6233Q1VC5*\nDates : *05/06/2026* – *07/06/2026* 📅\n\nVia ce WhatsApp, vous pouvez demander votre lien de check-in en ligne et recevoir les instructions d'arrivée.\nSi vous avez besoin d'aide avant ou pendant votre séjour, écrivez-nous ici 💬",
    cta: "🇬🇧 Pour continuer le check-in, appuyez sur le bouton *Ok* ou tapez *Ok*.",
  },
  policies: {
    guestBubble: "Pour continuer le processus, vous devez accepter nos conditions générales.",
    termsTitle: 'Règlement intérieur · HÉBERGEMENT TOURISTIQUE "{name}"',
    termsBodyLabel: "I.– ENREGISTREMENT",
    termsBodyText: "Chaque voyageur, qu'il soit seul ou en groupe, doit remplir un formulaire d'enregistrement individuellement ou par chambre, qui sera fourni à l'arrivée ou en ligne.",
    accept: "J'accepte les conditions générales",
  },
  guestPreview: {
    continue: "Continuer",
  },
  authorities: {
    ofTotal: "sur {total}",
    heading: "Informations requises en vertu du décret royal 933/2021 du gouvernement d'Espagne",
    intro: "En vertu du décret royal 933/2021, en vigueur depuis le 2 décembre 2024, nous devons recueillir les données suivantes pour respecter la réglementation de sécurité.",
    countryLabel: "Pays de résidence",
    sampleCountry: "🇪🇸 Espagne",
    cityLabel: "Ville de résidence",
    sampleCity: "Málaga",
    addressLabel: "Adresse de résidence",
    sampleAddress: "77 rue Larios",
    postalLabel: "Code postal de résidence",
  },
  locks: {
    embedEmpty: "Ajoutez d'abord une unité à l'annonce pour configurer les serrures et les accès.",
  },
  calendar: {
    iframeTitle: "Préparez votre calendrier",
    videoSoon: "La vidéo sera disponible ici très bientôt.",
    hint: "Lancez la vidéo et suivez les étapes : en un rien de temps, votre calendrier sera prêt à recevoir des réservations. 🎬",
  },
};
